import { useState } from 'react'
import { RatingModal } from '.'

/* eslint-disable tailwindcss/no-custom-classname */
export const Evaluation: React.FC = () => {
  const [open, setOpen] = useState(false)
  return (
    <div className="text-[15px] text-right">
      <button className="inline-block relative after:absolute after:top-[calc(50%-4px)] after:right-0 pr-[10px] mr-[5px] after:w-[9px] after:h-[9px] text-[#2dacdb] bg-none after:border-0 after:border-t-2 after:border-r-2 after:border-[#fe8d42] border-none after:border-solid after:rotate-45 cursor-pointer outline-none after:content-['']">
        <span className="text-[#2dacdb]" onClick={() => setOpen(true)}>
          評点基準について
        </span>
      </button>
      <RatingModal open={open} onClose={() => setOpen(false)} />
    </div>
  )
}
